import React from 'react';
import { Route, withRouter } from 'react-router-dom';
import OWAsyncRadio from '../visual_radio_input/VisualRadioInput';
import SubAssetSelectionStep from '../sub_asset_selection_step/SubAssetSelectionStep';
import { spendCategoriesRestCrudThunksForSupplier } from '../../thunks/spend_categories_thunks';
import { connect } from 'react-redux';
import {
	problemTypesRestCrudThunksForSupplier,
	problemTypesTopLevelForSupplier,
} from '../../thunks/problem_types_thunks';
import { assetsRestCrudThunksForSupplier } from '../../thunks/assets_thunks';
import { SUB_ASSETS_TARGET_COLLECTION } from '../../reducers/assets_reducer';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { MenuOutlined } from '@ant-design/icons';
import { Button, Drawer, Input, InputNumber, Menu, message, Modal, Progress, Table } from 'antd';
import { getBackendUri } from '../../utils/EnvConfigUtils';
import { imageUploadValidation, normFile } from '../../utils/ImageUtils';
import { getProtectedImageUriForSupplier } from '../../utils/FileAccessUtils';
import { ROLE_TYPES, WO_STEP_NAMES } from '../../utils/DataConstants';
import {
	checkIsWarrantyWorkOrder,
	filterKeys,
	getFiltersFromLocation,
	getImageCountErrorRules,
	getWarrantyStatus,
	nullSafeGet,
	nullSafeGetOrElse,
	mergeTroubleshootingRoutes,
	getElementAt,
	isPositiveNumber,
	getCurrency,
} from '../../utils/DataAccessUtils';
import OWRadio from '../static_visual_radio_input/StaticVisualRadioInput';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../../actions/work_orders_actions';
import {
	workOrderPrioritiesRestCrudThunksForSupplier,
	workOrderPrioritiesWithoutPMRestCrudThunksForSupplier,
} from '../../thunks/work_order_priorities_thunks';
import {
	linkWorkOrderForSupplier,
	workOrdersRestCrudThunksForSupplier,
	findDuplicateWorkOrdersForSupplier,
} from '../../thunks/work_orders_thunks';
import { supplierFacilitiesRestCrudThunksForSupplier } from '../../thunks/supplier_facilities_thunks';
import ServiceRequestLocationRender, {
	renderLocationRecord,
} from '../service_request_location_render/ServiceRequestLocationRender';
import { workOrderAttributesRestCrudThunksForSupplier } from '../../thunks/work_order_attributes_thunks';
import {
	areasRestCrudThunksForSupplier,
	areasTopLevelForSupplier,
} from '../../thunks/areas_thunks';
import { retrieveCachedUserDetails } from '../../thunks/session_thunks';
import { getBackLinkStates, getQueryStringFromObject } from '../../utils/HistoryUtils';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { troubleshootingRestCrudThunksForSupplier } from '../../thunks/troubleshooting_thunks';
import TroubleshootingDisplay from '../common/TroubleshootingDisplay';
import AssetNumberDisplay from '../asset_row_display/AssetNumberDisplay';
import { troubleshootingAnswersRestCrudThunksForSupplier } from '../../thunks/troubleshooting_answer_thunks';
import {
	buildTroubleshootingParams,
	getExistingTsAnswersFromStateForWOTsRoute,
	getTroubleshootingAnswersForNecessaryWOSteps,
	getUpdatedTroubleshootingStates,
	getUpdatedTsAnswersState,
} from '../../utils/TroubleshootingUtils';
import WorkOrderRowDisplay from '../work_order_row_display/WorkOrderRowDisplay';
import OWUpload from '../OWUpload';
import {
	captureDuplicateCheckRun,
	captureDuplicateResolved,
	getAssetFilterForWOCreation,
	getWorkOrderArchivalKey,
	handleDuplicateCheckOnTitle,
	isWorkOrderDuplicationEnabled,
	OPEN_WORK_ORDER_DISPLAY_STATUSES,
	onCancelRequest,
	WIZARD_NAMES,
} from '../../utils/WorkOrderUtils';
import { walkthroughsRestCrudThunksForSupplier } from '../../thunks/walkthroughs_thunks';
import WorkOrderSummary from '../common/WorkOrderSummary';
import { WORK_ORDER_PRIORITIES_CRUD_ACTION_CREATORS } from '../../actions/work_order_priorities_actions';
import { contractorLocationsRestCrudThunksForSupplier } from '../../thunks/contractor_locations_thunks';
import {
	contractorProblemTypesRestCrudThunksForSupplier,
	contractorProblemTypesTopLevel,
} from '../../thunks/contractor_problem_types_thunks';
import { contractorClientsRestCrudThunksForSupplier } from '../../thunks/contractor_clients_thunks';
import { contractorWOPrioritiesRestCrudThunksForSupplier } from '../../thunks/contractor_wo_priorities_thunks';
import { locationsRestCrudThunksForSupplier } from '../../thunks/locations_thunks';
import { WorkOrderCreationDependentFieldOrder } from '../new_work_order_wizard_page/wo_creation_constants';
import { workOrderSearchAndAPIAdaptor } from '../../thunks/work_orders_thunks_wrapper';
import WorkOrderTableRowWithoutActions from '../work_order_table_row_without_actions/WorkOrderTableRowWithoutActions';

require('./SupplierNewWorkOrderWizardPage.less');

const duplicateWorkOrderColumns = [
	{
		title: 'Name',
		dataIndex: 'id',
		render: (text, item) => <WorkOrderTableRowWithoutActions record={item} openInNewTab />,
	},
];

interface SupplierNewWorkOrderWizardProps extends FormComponentProps {
	onSubmit: any;
	onCancel: any;
	redirectForwardUrl: any;
	saveFormData: any;
	visible: boolean;
	createErrors: any;
	updateErrors: any;
	creating: boolean;
	updating: boolean;
	location: any;
	asset: any;
	currentUser: any;
}

const DEFAULT_BACK_PATH = '/supplier/workOrders';

class ContractorNewWorkOrderWizardPage extends React.Component<any, any> {
	formRefs: any;

	constructor(props) {
		super(props);
		this.formRefs = {};
		const urlParams = new URLSearchParams(props.location.search);
		const allPhotos = urlParams.get('images')
			? urlParams
					.get('images')
					.split(',')
					.map((p) => {
						const [fileName, fileId] = p.split('/');
						return {
							uid: fileId,
							lastModified: Date.now(),
							lastModifiedDate: new Date().toISOString(),
							name: fileName,
							size: 18304,
							type: 'image',
							percent: 100,
							originFileObj: {
								uid: fileId,
							},
							status: 'done',
							url: getProtectedImageUriForSupplier(fileId, fileName, 800, 800),
							thumbUrl: getProtectedImageUriForSupplier(fileId, fileName, 100, 100),
							response: {
								data: {
									fileName: fileName,
									fileId: fileId,
								},
							},
						};
					})
			: [];
		const walkthroughId = urlParams.get('walkthroughId');
		const walkthroughTaskIndex = urlParams.get('walkthroughTaskIndex');
		const linkedWorkOrderId = urlParams.get('linkedWorkOrderId');
		const siteSurveyTaskTitleId = urlParams.get('siteSurveyTaskTitleId');
		const onlyForPreview = urlParams.get('onlyForPreview');
		this.state = {
			allPhotos: allPhotos || [],
			willChooseDates: false,
			chosenDates: [],
			willUploadPicture: false,
			uploadLoading: false,
			pictureURL: null,
			locations: [],
			locationUpdateVisible: false,
			userContact: {},
			previewVisible: false,
			previewImage: false,
			navMenuVisible: false,
			location: {},
			woPriority: {},
			userLocation: {},
			problemType: {},
			area: {},
			problemTypePriorLevelId: null,
			problemTypePriorLevel: null,
			spendCategoryId: null,
			industryId: 1,
			buyerCompanyId: -1,
			supplier: null,
			nte: undefined,
			hasSubAssets: false,
			selectedSubAssetIds: [],

			currentRoute: '',
			backLinkParams: '',
			backLinkTo: DEFAULT_BACK_PATH,
			troubleshootingRoutes: [],
			troubleshootingAnswers: [],
			tsAnswerUploading: false,
			currencyExchangeRateLocationToSupplier: 1,
			currencyExchangeRateBuyerToLocation: 1,
			numPicturesRequired: 0,
			isProcessing: false,
			walkthroughId,
			walkthroughTaskIndex,
			onlyForPreview,
			linkedWorkOrderId,
			siteSurveyTaskTitleId,
			isContractorLocationOnly: true,
			contractorClient: {},
			duplicateCheckSource: null as 'asset' | 'title' | null,
		};
	}

	componentDidMount() {
		document.body.classList.add('supplierNewWorkOrderWizardBody');
		const { fetchContractorClients, history, location } = this.props;
		this.setState(getBackLinkStates(location, DEFAULT_BACK_PATH));

		fetchContractorClients({}).then(() => {
			history.push('/supplier/workOrders/newContractorWorkOrder/contractorClients');
		});
		document.body.classList.add('supplierNewWorkOrderWizardBody');
	}

	componentWillUnmount() {
		document.body.classList.remove('supplierNewWorkOrderWizardBody');
		const { clearFormData } = this.props;
		clearFormData();
	}

	isProcessing = () => {
		const { creating } = this.props;
		return creating || this.state.isProcessing || this.state.tsAnswerUploading;
	};

	setProcessing = (isProcessing) => {
		this.setState({ isProcessing });
	};

	removeTroubleshootingRoutes = (currentRoute) => {
		const routeHierarchy = [
			WO_STEP_NAMES.LOCATIONS,
			WO_STEP_NAMES.AREA_TOP_LEVEL,
			WO_STEP_NAMES.AREA_NEXT_LEVEL,
			WO_STEP_NAMES.AREA_NEXT_BRANCH,
			WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH,
			WO_STEP_NAMES.ASSET,
			WO_STEP_NAMES.ASSET_CONDITION,
			WO_STEP_NAMES.PRIORITY,
			WO_STEP_NAMES.SUPPLIER,
		];
		this.setState(getUpdatedTroubleshootingStates(routeHierarchy, currentRoute, this.state));
	};

	onRouteChanged = () => {
		const pathName = nullSafeGetOrElse('props.location.pathname', this, '');
		const currentRoute = getElementAt(pathName.split('/'), -1);
		this.removeTroubleshootingRoutes(currentRoute);
		const params = getFiltersFromLocation(this.props.location);
		const allowedStateKeys = [
			'area2Available',
			'areaPriorLevelId',
			'areaPriorLevel',
			'problemTypeLevel2Available',
			'problemTypeLevel3Available',
			'problemTypePriorLevelId',
			'problemTypePriorLevel',
			'spendCategoryId',
		];
		const newState = {
			...filterKeys(params, allowedStateKeys, true),
			currentRoute,
		};
		this.setState(newState);
	};

	getTroubleshootingParams = (previousStep) => {
		const problemTypeId =
			this.state.problemTypeLevel3Id ||
			this.state.problemTypeLevel2Id ||
			this.state.problemTypeLevel1Id;
		return buildTroubleshootingParams(
			{
				locationId: nullSafeGet('state.location.id', this),
				problemTypeId,
				assetId: nullSafeGet('state.asset.id', this),
				assetTypeId: nullSafeGet('state.asset.assetTypeId', this),
				workOrderPriorityId: nullSafeGet('state.woPriority.id', this),
				supplierFacilityId: nullSafeGet('state.supplier.facility.id', this),
			},
			previousStep
		);
	};

	checkTroubleShooting = (args, previousStep) => {
		const { fetchTroubleshooting } = this.props;
		const params = this.getTroubleshootingParams(previousStep);
		if (!Object.keys(params).length) {
			this.proceedToNextStep(args);
			return Promise.resolve();
		}
		return fetchTroubleshooting(params)
			.then((res) => {
				if (res && res.length > 0) {
					const existingTroubleshootingRoutes = nullSafeGetOrElse(
						'state.troubleshootingRoutes',
						this,
						[]
					);
					if (existingTroubleshootingRoutes.find((_) => _.id === res[0].id)) {
						this.proceedToNextStep(args);
					} else {
						this.setState({
							troubleshootingRoutes: [
								...existingTroubleshootingRoutes,
								...[
									{
										...res[0],
										args,
										previousStep,
									},
								],
							],
						});
						this.proceedToNextStep({
							validationSteps: [],
							destination: `troubleshooting-${res[0].id}`,
						});
					}
				} else {
					this.proceedToNextStep(args);
				}
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	componentDidUpdate(prevProps): void {
		if (this.props.location !== prevProps.location) {
			this.onRouteChanged();
		}
	}

	updateTroubleshootingAnswerIfAvailable = (workOrder) => {
		const { createTroubleshootingAnswersBulk } = this.props;
		const answers = nullSafeGetOrElse('troubleshootingAnswers', this.state, []);
		return new Promise((resolve, reject) => {
			if (answers.length > 0) {
				this.setState({ tsAnswerUploading: true });
				createTroubleshootingAnswersBulk(
					answers.map((_) => ({
						..._,
						workOrderId: workOrder.id,
					}))
				)
					.then((res) => {
						resolve(res);
					})
					.catch((err) => {
						message.error(err);
						reject(err);
					})
					.finally(() => this.setState({ tsAnswerUploading: false }));
			} else {
				resolve(true);
			}
		});
	};
	updateLinkingIfAvailable = (newWorkOrder) => {
		return new Promise((resolve, reject) => {
			const { linkWorkOrders } = this.props;
			if (this.state.linkedWorkOrderId) {
				return linkWorkOrders(this.state.linkedWorkOrderId, [newWorkOrder.id], true).then(() => {
					resolve(true);
				});
			} else {
				resolve(true);
			}
		});
	};

	handleSubmit = () => {
		const { form, formData, history, currentUser, submitWorkOrderForm, deleteWorkOrderFromRedux } =
			this.props;
		const { location, contractorClient, problemType, currencyExchangeRateLocationToSupplier } =
			this.state;
		form.validateFields((err, values) => {
			if (!err) {
				// put image data into proper format to persist
				const picturesInfo = this.state.allPhotos.map((p) => {
					const fileName = nullSafeGetOrElse('response.data.fileName', p, '');
					const fileId = nullSafeGetOrElse('response.data.fileId', p, '');
					return `${fileId}/${fileName}`;
				});
				const contractorDetails = {
					contractorContacts: [],
				};
				const workOrder = {
					title: values.title,
					[this.state.isContractorLocationOnly ? 'contractorProblemTypeId' : 'problemTypeId']:
						parseInt(nullSafeGet('id', problemType), 10) || 1,
					[this.state.isContractorLocationOnly ? 'contractorWoPriorityId' : 'woPriorityId']:
						nullSafeGet('id', this.state.woPriority)
							? parseInt(nullSafeGet('id', this.state.woPriority), 10)
							: null,
					contractorClientId: nullSafeGet('contractorClient.id', this.state)
						? parseInt(nullSafeGet('contractorClient.id', this.state), 10)
						: undefined,
					spendCategoryId: parseInt(this.state.spendCategoryId, 10),
					[this.state.isContractorLocationOnly ? 'contractorLocationId' : 'locationId']: parseInt(
						location.id,
						10
					),
					assetId: formData.assetId ? parseInt(formData.assetId, 10) : null,
					...(formData.assetId && {
						isAssetDown: formData.isAssetDown === 'true' ? true : false,
					}),
					// Only include subAssetIds when the picker would have been visible — i.e.
					// an asset is selected AND the loaded asset has sub-assets.
					...(formData.assetId && nullSafeGetOrElse('subAssetCount', this.state.asset, 0) > 0
						? {
								subAssetIds:
									this.state.selectedSubAssetIds.length > 0 ? this.state.selectedSubAssetIds : null,
						  }
						: {}),
					areaId: nullSafeGet('id', this.state.area)
						? parseInt(nullSafeGet('id', this.state.area), 10)
						: null,
					images: picturesInfo,
					currencyExchangeRateLocationToSupplier: currencyExchangeRateLocationToSupplier,
					description: formData.additionalInfo,
					buyerCompanyId: nullSafeGetOrElse(
						'buyerCompanyId',
						location,
						nullSafeGet('clientBuyerCompany.buyerCompanyId', contractorClient)
					),
					createdBy: currentUser.email,
					supplierFacilityId: currentUser.facility.id,
					contractorDetails: contractorDetails,
					notes: [],
					supplierAttachments: [],
					...(this.state.isContractorLocationOnly && {
						status: 'ConfirmedByServiceProvider',
						displayStatus: 'InProgress',
					}),
					nte: this.state.nte ? this.state.nte : undefined,
					walkThroughId: this.state.walkthroughId ? parseInt(this.state.walkthroughId) : undefined,
					siteSurveyTaskTitleId: this.state.siteSurveyTaskTitleId
						? this.state.siteSurveyTaskTitleId
						: undefined,
				};

				submitWorkOrderForm(workOrder).then((rec) => {
					const promises = [
						this.updateTroubleshootingAnswerIfAvailable(rec),
						this.updateLinkingIfAvailable(rec),
					];
					deleteWorkOrderFromRedux(rec);

					Promise.all(promises).then(() => {
						if (this.state.walkthroughId) {
							history.push(
								`/supplier/siteSurveys/walkthrough/detail/${this.state.walkthroughId}/details`
							);
						} else if (this.state.linkedWorkOrderId) {
							history.push(
								`/supplier/workOrders/detail/${this.state.linkedWorkOrderId}/linked`.concat(
									'?',
									this.state.backLinkParams
								)
							);
						} else {
							history.push(
								`/supplier/workOrders/detail/${rec.id}`.concat('?', this.state.backLinkParams)
							);
						}
					});
				});
			}
		});
	};

	handleUploadPicture = (value) => {
		value.target.value === 'yes'
			? this.setState({
					willUploadPicture: true,
			  })
			: this.setState({
					willUploadPicture: false,
			  });
	};

	proceedToNextStep = (values) => {
		const { validationSteps, destination, useReplace = false, params = {} } = values;
		const { form, history } = this.props;
		form.validateFields(validationSteps, (err) => {
			if (err) {
				console.log(err);
				this.setProcessing(false);
				return;
			}
			window.scrollTo(0, 0);
			const navigateFunction = useReplace ? history.replace : history.push;
			const queryString = getQueryStringFromObject(params);
			const navigateTo = `/supplier/workOrders/newContractorWorkOrder/${destination}${
				queryString ? `?${queryString}` : ''
			}`;
			navigateFunction(navigateTo);
			this.setProcessing(false);
		});
	};

	goNext = (
		validationSteps,
		destination,
		stepName,
		ingnoreTroubleshooting = false,
		useReplace = false,
		params = {}
	) => {
		this.setProcessing(true);
		const args = {
			validationSteps,
			destination,
			useReplace,
			params,
		};

		const requiredSteps = [
			// WO_STEP_NAMES.LOCATIONS,
			// WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
			// WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL,
			// WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH,
			// WO_STEP_NAMES.ASSET,
			// WO_STEP_NAMES.PRIORITY,
			// WO_STEP_NAMES.SUPPLIER,
		];

		if (!ingnoreTroubleshooting && requiredSteps.includes(stepName)) {
			return this.checkTroubleShooting(args, stepName);
		} else {
			this.proceedToNextStep(args);
		}
	};

	cancelRequest = () => this.props.history.push(this.state.backLinkTo);

	goBack = () => {
		const { history } = this.props;
		history.goBack();
	};

	goNextAfterBriefPause = (
		validationSteps,
		destination,
		currentStep,
		ignoreTroubleshooting = false
	) => {
		this.setProcessing(true);
		setTimeout(
			() => this.goNext(validationSteps, destination, currentStep, ignoreTroubleshooting),
			350
		);
	};

	resetFieldAFter = (changedState) => {
		const index = WorkOrderCreationDependentFieldOrder.findIndex((_) => _.key === changedState);
		const newState =
			index > -1
				? WorkOrderCreationDependentFieldOrder.slice(index + 1).reduce((obj, field) => {
						obj[field.key] = field.default;
						return obj;
				  }, {})
				: {};
		this.setState(newState);
	};

	changeId = (key, value) => {
		this.setState({ [key]: value });
		this.resetFieldAFter(key);
	};

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	handlePreview = (obj) => {
		let thumbUrl = null;
		let fullUrl = null;
		let photoInfo = null;
		if (obj.response.data) {
			const imgFileId = obj.response.data.fileId;
			const imgFileName = obj.response.data.fileName;
			thumbUrl = getProtectedImageUriForSupplier(imgFileId, imgFileName, 100, 100);
			fullUrl = getProtectedImageUriForSupplier(imgFileId, imgFileName, 800, 800);
			photoInfo = {
				uid: imgFileId,
				size: 1,
				name: imgFileName,
				filename: imgFileName,
				url: fullUrl,
				status: 'done',
				thumbUrl: thumbUrl,
				response: { data: { fileName: imgFileName, fileId: imgFileId } },
				type: 'image/jpeg',
			};
		}
		this.setState({
			photoInfo: [photoInfo],
			previewImage: fullUrl || thumbUrl,
			previewVisible: true,
		});
	};

	handleImageUpdate = (info) => {
		this.setState({ allPhotos: info.fileList });
	};

	handleUserLocation = () => {
		const { userLocation } = this.state;
		const { form, saveFormData } = this.props;
		form.setFieldsValue({ locationId: userLocation.id });
		saveFormData({ locationId: userLocation.id });
		this.handleLocation(userLocation.id);
	};

	handleNumPicturesRequiredForProblemType = (problemType) => {
		this.setState({
			numPicturesRequired: nullSafeGetOrElse('serviceRequestNumPicturesRequired', problemType, 0),
		});
	};

	handleContractorProblemTypeChange = (contractorPTId) => {
		const { fetchContractorProblemType } = this.props;

		if (contractorPTId) {
			// const { currencyExchangeRateBuyerToLocation } = this.state;

			const problemTypePromise = fetchContractorProblemType(contractorPTId);

			return new Promise((resolve, reject) => {
				Promise.all([problemTypePromise])
					.then((values) => {
						const contractorProblemType = values[0];
						this.setState({ contractorProblemType });
						resolve(contractorProblemType);
					})
					.catch((err) => reject(err));
			});
		}
	};

	handleProblemTypeChange: any = (problemTypeId) => {
		const { fetchProblemType, fetchContractorProblemType } = this.props;

		if (problemTypeId) {
			const problemTypePromise = this.state.isContractorLocationOnly
				? fetchContractorProblemType(problemTypeId)
				: fetchProblemType(problemTypeId);

			return new Promise((resolve, reject) => {
				Promise.all([problemTypePromise])
					.then((values) => {
						const problemType = values[0];
						this.handleNumPicturesRequiredForProblemType(problemType);
						this.setState({ problemType });
						resolve(problemType);
					})
					.catch((err) => reject(err));
			});
		}
	};

	checkAssetAndProceed = (problemTypeId, currentStep, ignoreTroubleshooting = false) => {
		const { fetchAssets, companyConfig, currentUser } = this.props;
		this.setProcessing(true);
		return fetchAssets(
			getAssetFilterForWOCreation(ROLE_TYPES.SUPPLIER)(companyConfig, currentUser, this.state),
			null,
			{
				current: 1,
				pageSize: 1,
			}
		)
			.then((assets) => {
				const assetsAvailable = !!(assets && assets.length > 0);

				this.setState({ assetsAvailable });

				this.goNext(
					[],
					assetsAvailable ? WO_STEP_NAMES.ASSET : WO_STEP_NAMES.TITLE,
					currentStep,
					ignoreTroubleshooting
				);
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	actionForProblemTypeChangeOrClick = (
		{ problemTypeId, idLevelName, nextLevelAvailableName, currentStep, nextStep },
		ignoreTroublshooting = false,
		changeId = false
	) => {
		if (changeId) {
			this.changeId(idLevelName, problemTypeId);
		} else {
			this.setState({ [idLevelName]: problemTypeId });
		}
		this.setProcessing(true);
		this.handleProblemTypeChange(problemTypeId)
			.then((problemType) => {
				if (problemType.hasChildren) {
					this.goNext([], nextStep, currentStep, ignoreTroublshooting, false, {
						[nextLevelAvailableName]: true,
						problemTypePriorLevelId: problemTypeId,
						problemTypePriorLevel: problemType.name,
						spendCategoryId: problemType.spendCategoryId,
					});
				} else {
					this.setState(
						{
							[nextLevelAvailableName]: false,
							spendCategoryId: problemType.spendCategoryId,
							problemTypePriorLevelId: undefined,
							problemTypePriorLevel: undefined,
						},
						() => this.checkAssetAndProceed(problemTypeId, currentStep, ignoreTroublshooting)
					);
				}
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	handleProblemTypeTopLevelChange = (problemTypeId) => {
		this.actionForProblemTypeChangeOrClick(
			{
				problemTypeId,
				idLevelName: 'problemTypeLevel1Id',
				nextLevelAvailableName: 'problemTypeLevel2Available',
				currentStep: WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
				nextStep: WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL,
			},
			false,
			true
		);
	};

	handleProblemTypeTopLevelClick = (problemTypeId, ignoreTroubleshooting) => {
		this.actionForProblemTypeChangeOrClick(
			{
				problemTypeId,
				idLevelName: 'problemTypeLevel1Id',
				nextLevelAvailableName: 'problemTypeLevel2Available',
				currentStep: WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
				nextStep: WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL,
			},
			ignoreTroubleshooting,
			false
		);
	};

	handleProblemTypeNextLevelChange = (problemTypeId, ignoreTroubleshooting) => {
		this.actionForProblemTypeChangeOrClick(
			{
				problemTypeId,
				idLevelName: 'problemTypeLevel2Id',
				nextLevelAvailableName: 'problemTypeLevel3Available',
				currentStep: WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL,
				nextStep: WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH,
			},
			ignoreTroubleshooting,
			true
		);
	};

	handleProblemTypeNextLevelBranchChange = (problemTypeId) => {
		this.actionForProblemTypeChangeOrClick(
			{
				problemTypeId,
				idLevelName: 'problemTypeLevel3Id',
				nextLevelAvailableName: 'problemTypeLevel3Available',
				currentStep: WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL,
				nextStep: WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH,
			},
			false,
			true
		);
	};

	handleAreaTopLevelChange = (areaId, ignoreTroubleshooting) => {
		const { fetchArea } = this.props;
		this.changeId('areaLevel1Id', areaId);
		this.setProcessing(true);
		fetchArea(areaId)
			.then((area) => {
				this.setState({ area: area });
				if (area.hasChildren) {
					this.goNext(
						[],
						WO_STEP_NAMES.AREA_NEXT_LEVEL,
						WO_STEP_NAMES.AREA_TOP_LEVEL,
						ignoreTroubleshooting,
						false,
						{
							area2Available: true,
							areaPriorLevelId: areaId,
							areaPriorLevel: area.name,
						}
					);
				} else {
					if (area.problemTypeIds.length > 0) {
						this.setState({
							problemTypeIds: area.problemTypeIds.join(','),
						});
					}
					this.setState(
						{
							area2Available: false,
							areaPriorLevelId: undefined,
							areaPriorLevel: undefined,
						},
						() => {
							let nextStep = WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL;
							if (areaId == 6497) {
								nextStep = WO_STEP_NAMES.ASSET_CHECK;
							}
							this.goNext([], nextStep, WO_STEP_NAMES.AREA_TOP_LEVEL, ignoreTroubleshooting);
						}
					);
				}
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	handleAreaNextLevelChange = (areaId, ignoreTroubleshooting) => {
		const { fetchArea } = this.props;
		this.changeId('areaLevel2Id', areaId);
		this.setProcessing(true);
		fetchArea(areaId)
			.then((area) => {
				this.setState({ area: area });
				if (area.hasChildren) {
					this.goNext(
						[],
						WO_STEP_NAMES.AREA_NEXT_BRANCH,
						WO_STEP_NAMES.AREA_NEXT_LEVEL,
						ignoreTroubleshooting,
						false,
						{
							area3Available: true,
							areaPriorLevelId: areaId,
							areaPriorLevel: area.name,
						}
					);
				} else {
					if (area.problemTypeIds.length > 0) {
						this.setState({
							problemTypeIds: area.problemTypeIds.join(','),
						});
					}
					this.setState(
						{
							area3Available: false,
							areaPriorLevelId: undefined,
							areaPriorLevel: undefined,
						},
						() => {
							let nextStep = WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL;
							if (areaId == 6497) {
								nextStep = WO_STEP_NAMES.ASSET_CHECK;
							}
							this.goNext([], nextStep, WO_STEP_NAMES.AREA_NEXT_LEVEL, ignoreTroubleshooting);
						}
					);
				}
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	handleAreaNextLevelBranchChange = (areaId) => {
		const { fetchArea } = this.props;
		this.changeId('areaLevel3Id', areaId);
		this.setProcessing(true);
		fetchArea(areaId)
			.then((area) => {
				this.setState({ area });
				if (area.hasChildren) {
					this.goNext(
						[],
						WO_STEP_NAMES.AREA_NEXT_LEVEL,
						WO_STEP_NAMES.AREA_NEXT_BRANCH,
						false,
						false,
						{
							area4Available: true,
							areaPriorLevelId: areaId,
							areaPriorLevel: area.name,
						}
					);
				} else {
					if (area.problemTypeIds.length > 0) {
						this.setState({
							problemTypeIds: area.problemTypeIds.join(','),
						});
					}
					this.setState(
						{
							area4Available: false,
							areaPriorLevelId: undefined,
							areaPriorLevel: undefined,
						},
						() => {
							let nextStep = WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL;
							if (areaId == 6497) {
								nextStep = WO_STEP_NAMES.ASSET_CHECK;
							}
							this.goNext([], nextStep, WO_STEP_NAMES.AREA_NEXT_BRANCH);
						}
					);
				}
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	handleClientClick = () => {
		this.goNextAfterBriefPause([], WO_STEP_NAMES.LOCATIONS, WO_STEP_NAMES.CONTRACTOR_CLIENT);
	};

	handleClient = (clientId) => {
		const { fetchContractorClient } = this.props;
		this.setProcessing(true);
		fetchContractorClient(clientId)
			.then((contractorClient) => {
				this.setState(
					{
						contractorClient,
						isContractorLocationOnly: !nullSafeGet('clientBuyerCompany', contractorClient),
					},
					() => {
						this.handleClientClick();
					}
				);
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	handleLocation = (locationId) => {
		const { fetchContractorLocation, fetchLocation } = this.props;
		const locationPromise = this.state.isContractorLocationOnly
			? fetchContractorLocation(locationId)
			: fetchLocation(locationId);
		this.resetFieldAFter('locations');
		this.setProcessing(true);
		locationPromise
			.then((location) => {
				this.setState(
					{
						location,
						buyerCompanyId: nullSafeGetOrElse(
							'buyerCompanyId',
							location,
							nullSafeGet('clientBuyerCompanyId', location)
						),
						industryId: nullSafeGetOrElse(
							'buyerCompany.industryId',
							location,
							nullSafeGet('clientBuyerCompany.industryId', location)
						),
					},
					() => {
						this.goNextAfterBriefPause(
							[],
							WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
							WO_STEP_NAMES.LOCATIONS
						);
					}
				);
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	handleLocationClick = (locationId, ignoreTroubleshooting) => {
		const { fetchAreasTopLevel, locations } = this.props;
		const location = (locations.records || {})[locationId];
		this.setProcessing(true);
		fetchAreasTopLevel({
			locationId,
			...(location && location.locationTypeId && { locationTypeId: location.locationTypeId }),
		})
			.then((areas) => {
				if (areas && areas.length > 0) {
					this.goNextAfterBriefPause(
						[],
						WO_STEP_NAMES.AREA_TOP_LEVEL,
						WO_STEP_NAMES.LOCATIONS,
						ignoreTroubleshooting
					);
				} else {
					this.goNextAfterBriefPause(
						[],
						WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
						WO_STEP_NAMES.LOCATIONS,
						ignoreTroubleshooting
					);
				}
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	handleWorkOrderPriorityClick = () => {
		this.goNext([], WO_STEP_NAMES.COMPLETION, WO_STEP_NAMES.PRIORITY);
	};

	handleWorkOrderPriority = (woPriorityId) => {
		const { fetchWorkOrderPriority } = this.props;
		this.setProcessing(true);
		fetchWorkOrderPriority(woPriorityId)
			.then((woPriority) => {
				this.setState({ woPriority }, () => {
					this.handleWorkOrderPriorityClick();
				});
			})
			.finally(() => {
				this.setProcessing(false);
			});
	};

	handleContractorWOPriorityClick = () => {
		this.goNext([], WO_STEP_NAMES.NTE, WO_STEP_NAMES.PRIORITY);
	};

	handleContractorWOPriority = (woPriorityId) => {
		const { fetchContractorWOPriority } = this.props;
		this.setProcessing(true);
		fetchContractorWOPriority(woPriorityId)
			.then((woPriority) => {
				this.setState({ woPriority }, () => {
					this.handleContractorWOPriorityClick();
				});
			})
			.finally(() => {
				this.setProcessing(false);
			});
	};

	setNTE = (nte) => {
		const { form } = this.props;
		this.setState({ nte });
		form.setFieldsValue({
			nte: isPositiveNumber(nte) ? parseFloat(nte).toFixed(2) : undefined,
		});
	};

	handleAsset = (assetId) => {
		const { fetchAsset, fetchWorkOrders, form, history, currentUser } = this.props;
		const { getFieldValue } = form;

		const isAssetKnown = getFieldValue('isAssetKnown');
		if (isAssetKnown === 'true') {
			history.push(
				`/supplier/assets/${assetId}/newWorkOrder?areaId=${nullSafeGet('id', this.state.area)}`
			);
			return;
		}
		this.setProcessing(true);
		fetchAsset(assetId)
			.then((asset) => {
				const hasSubAssets = nullSafeGetOrElse('subAssetCount', asset, 0) > 0;
				this.setState({ asset, hasSubAssets, selectedSubAssetIds: [] }, () => {
					if (isWorkOrderDuplicationEnabled()) {
						this.goNext([], this.nextAfterAsset(), WO_STEP_NAMES.ASSET);
						return;
					}
					fetchWorkOrders({
						assetId,
						locationId: nullSafeGet('location.id', this.state),
						isPM: false,
						displayStatuses: OPEN_WORK_ORDER_DISPLAY_STATUSES,
						[getWorkOrderArchivalKey(currentUser)]: false,
					})
						.then((workOrders) => {
							captureDuplicateCheckRun({
								wizard: WIZARD_NAMES.CONTRACTOR_NEW_WORK_ORDER,
								source: 'asset',
								rawWorkOrders: workOrders,
								shownWorkOrders: workOrders,
								context: {
									locationId: nullSafeGet('location.id', this.state),
									assetId,
								},
							});
							if (!workOrders || workOrders.length === 0) {
								this.goNext([], this.nextAfterAsset(), WO_STEP_NAMES.ASSET);
							} else {
								this.setState({
									duplicateWorkOrders: workOrders,
									duplicateCheckSource: 'asset',
								});
								this.goNext([], WO_STEP_NAMES.DUPLICATE_CHECK, WO_STEP_NAMES.ASSET);
							}
						})
						.catch(() => {
							this.setProcessing(false);
						});
				});
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};
	handleDuplicate = (resp) => {
		captureDuplicateResolved({
			wizard: WIZARD_NAMES.CONTRACTOR_NEW_WORK_ORDER,
			source: this.state.duplicateCheckSource,
			resp,
			shownCount: nullSafeGetOrElse('duplicateWorkOrders.length', this.state, 0),
		});
		if (resp == 1) {
			this.props.history.push('/supplier/workOrders');
		} else {
			const destination =
				this.state.duplicateCheckSource === 'title' ? WO_STEP_NAMES.PHOTOS : this.nextAfterAsset();
			this.goNextAfterBriefPause([], destination, WO_STEP_NAMES.DUPLICATE_CHECK);
		}
	};

	handleTitle = () =>
		handleDuplicateCheckOnTitle({
			state: this.state,
			form: this.props.form,
			currentUser: this.props.currentUser,
			findDuplicateWorkOrders: this.props.findDuplicateWorkOrders,
			setState: (state) => this.setState(state),
			setProcessing: this.setProcessing,
			goNext: this.goNext,
			goNextAfterBriefPause: this.goNextAfterBriefPause,
			wizard: WIZARD_NAMES.CONTRACTOR_NEW_WORK_ORDER,
		});

	handleAssetClick = () => {
		this.goNext([], this.nextAfterAsset(), WO_STEP_NAMES.ASSET);
	};

	nextAfterAsset = () =>
		this.state.hasSubAssets ? WO_STEP_NAMES.SUB_ASSET : WO_STEP_NAMES.ASSET_CONDITION;

	handleNavMenuClose = () => {
		this.setState({ navMenuVisible: false });
	};

	handleAssetCondition = () => {
		this.goNextAfterBriefPause([], WO_STEP_NAMES.TITLE, WO_STEP_NAMES.ASSET_CONDITION);
	};

	handleAssetCheck = (value) => {
		if (value === 'true') {
			this.goNext([], WO_STEP_NAMES.ASSET, WO_STEP_NAMES.AREA_TOP_LEVEL, false);
		} else {
			this.goNext([], WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL, WO_STEP_NAMES.AREA_TOP_LEVEL, false);
		}
	};

	handleNavMenuOpen = () => {
		this.setState({ navMenuVisible: true });
	};

	handleNavMenuClick = (e) => {
		const methods = {
			areasTopLevel: () => this.handleLocationClick(nullSafeGet('location.id', this.state), true),
			areasNextLevel: () => this.handleAreaTopLevelChange(this.state.areaLevel1Id, true),
			areasNextBranch: () => this.handleAreaNextLevelChange(this.state.areaLevel2Id, true),
			problemTypeNextLevel: () =>
				this.handleProblemTypeTopLevelClick(this.state.problemTypeLevel1Id, true),
			problemTypeNextBranch: () =>
				this.handleProblemTypeNextLevelChange(this.state.problemTypeLevel2Id, true),
		};
		methods[e.key] ? methods[e.key]() : this.goNext([], e.key, '', true);
	};

	handleCancel = () => this.setState({ previewVisible: false });

	isTroubleshootingAllowedToProceed = (checkSteps) => {
		const tsRoutes = nullSafeGetOrElse('state.troubleshootingRoutes', this, []);
		const allowedToProceed =
			tsRoutes
				.filter((_) => checkSteps.includes(_.previousStep))
				.filter((_) => !nullSafeGetOrElse('troubleshootingSteps', _, [{}])[0].canProceedToNextStep)
				.length === 0;

		return allowedToProceed;
	};

	isLocationFieldsSelected = () => {
		const {
			userLocation,
			location,
			areas,
			areaLevel1Id,
			area2Available,
			area3Available,
			areaLevel2Id,
			areaLevel3Id,
		} = this.state;
		const locationFieldSelected =
			userLocation.id || location.id
				? areas && areas.length > 0
					? areaLevel1Id
						? area2Available
							? areaLevel2Id
								? area3Available
									? areaLevel3Id
										? true
										: false
									: true
								: false
							: true
						: false
					: true
				: false;

		const checkSteps = [WO_STEP_NAMES.LOCATIONS];

		return locationFieldSelected && this.isTroubleshootingAllowedToProceed(checkSteps);
	};

	isProblemTypeAndAssetSelected = () => {
		const {
			problemTypeLevel1Id,
			problemTypeLevel2Available,
			problemTypeLevel2Id,
			problemTypeLevel3Available,
			problemTypeLevel3Id,
		} = this.state;
		const problemTypeSelected = problemTypeLevel1Id
			? problemTypeLevel2Available
				? problemTypeLevel2Id
					? problemTypeLevel3Available
						? problemTypeLevel3Id
							? true
							: false
						: true
					: false
				: true
			: false;

		const checkSteps = [
			WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH,
		];
		return problemTypeSelected && this.isTroubleshootingAllowedToProceed(checkSteps);
	};

	isPrioritySelected = () =>
		nullSafeGet('woPriority.id', this.state) &&
		this.isTroubleshootingAllowedToProceed([WO_STEP_NAMES.PRIORITY]);

	render() {
		const {
			location,
			assets,
			areas,
			fetchAreas,
			fetchMultipleAreas,
			fetchAreasTopLevel,
			fetchAssets,
			fetchMultipleAssets,
			locations,
			fetchLocationsLite,
			fetchMultipleLocations,
			contractorLocations,
			creating,
			fetchContractorLocations,
			fetchMultipleContractorLocations,
			formData,
			workOrderPriorities,
			fetchWorkOrderPriorities,
			fetchMultipleWorkOrderPriorities,
			fetchMultipleContractorWOPriorities,
			fetchContractorWOPriorities,
			contractorWOPriorities,
			problemTypes,
			fetchProblemTypes,
			fetchMultipleProblemTypes,
			fetchProblemTypesTopLevel,
			contractorProblemTypes,
			fetchContractorProblemTypes,
			fetchMultipleContractorProblemTypes,
			fetchContractorProblemTypesTopLevel,
			form,
			companyConfig,
			currentUser,
			contractorClients,
			fetchContractorClients,
			fetchMultipleContractorClients,
		} = this.props;
		const { getFieldDecorator, getFieldValue } = form;
		const { previewVisible, previewImage, nte } = this.state;
		const BACKEND_URI = getBackendUri();
		const uploadHeaders = { 'X-Auth-Token': retrieveCachedUserDetails(['token']).token };
		const currency = getCurrency({ currentUser });

		const { locationTsAnswer, problemTypeTsAnswer, priorityTsAnswer } =
			getTroubleshootingAnswersForNecessaryWOSteps(this.state);

		const workOrderDetails = [
			{ key: 'Location', value: nullSafeGetOrElse('name', this.state.location, '') },
			...locationTsAnswer,
			{ key: 'Area', value: nullSafeGetOrElse('hierarchyName', this.state.area, '') },
			{
				key: 'Problem Type',
				value: nullSafeGetOrElse('hierarchyName', this.state.problemType, ''),
			},
			...problemTypeTsAnswer,
			{ key: 'Asset', value: nullSafeGetOrElse('name', this.state.asset, '') },
			{
				key: 'Sub Assets',
				value: this.state.selectedSubAssetIds
					.map((id) => nullSafeGet(`records.${id}.name`, assets))
					.filter(Boolean)
					.join(', '),
			},
			...(nullSafeGetOrElse('name', this.state.asset, '')
				? [
						{
							key: 'Is the Asset Under Warranty?',
							value: checkIsWarrantyWorkOrder(
								nullSafeGet('asset.warranties.0', this.state),
								nullSafeGet('supplierFacilityId', formData)
							)
								? 'Yes'
								: 'No',
						},
						{
							key: 'Is the Asset functioning?',
							value: formData.isAssetDown === 'true' ? 'No' : 'Yes',
						},
				  ]
				: []),
			{ key: 'Title', value: nullSafeGetOrElse('title', formData, '') },
			{ key: 'Priority', value: nullSafeGetOrElse('woPriority.name', this.state, '') },
			...priorityTsAnswer,
			...(isPositiveNumber(nte)
				? [
						{
							key: 'NTE',
							value: getCurrency({ currentUser }).format(nte),
						},
				  ]
				: []),
		];

		const photoStrings = (getFieldValue('images') || []).map((p) => {
			const fileName = nullSafeGetOrElse('response.data.fileName', p, '');
			const fileId = nullSafeGetOrElse('response.data.fileId', p, '');
			return `${fileId}/${fileName}`;
		});

		const minPhotosCount = nullSafeGetOrElse('state.numPicturesRequired', this, 0);

		const imageCountErrorMessage = `You need to upload at least ${minPhotosCount} photo${
			minPhotosCount > 1 ? 's' : ''
		}`;

		const imageCountMatched =
			minPhotosCount <= nullSafeGetOrElse('length', getFieldValue('images'), 0);

		const getTroubleshootingSteps = () => {
			const troubleshootingRoutes = nullSafeGetOrElse('state.troubleshootingRoutes', this, []);
			return troubleshootingRoutes.reduce((steps, route) => {
				const existingAnswer = getExistingTsAnswersFromStateForWOTsRoute(this.state, route);
				return {
					...steps,
					[`troubleshooting-${route.id}`]: {
						id: `t-${route.id}`,
						label: 'Troubleshooting',
						component: (
							<TroubleshootingDisplay
								troubleshootingSteps={route.troubleshootingSteps}
								onBack={this.goBack}
								onNextStep={(answers) => {
									if (nullSafeGet('0', answers)) {
										const troubleshootingAnswers = getUpdatedTsAnswersState(
											this.state,
											route,
											answers
										);
										this.setState({ troubleshootingAnswers });
									}
									route.args && this.proceedToNextStep(route.args);
								}}
								onCancel={this.cancelRequest}
								existingAnswer={existingAnswer}
							/>
						),
					},
				};
			}, {});
		};

		const defaultNavMenuSteps = [
			{
				title: 'locations',
				enabled: true,
			},
			...(this.state.areas && this.state.areas.length > 0
				? [
						{
							title: 'areasTopLevel',
							enabled: true,
						},
				  ]
				: []),
			...(this.state.area2Available
				? [
						{
							title: 'areasNextLevel',
							enabled: true,
						},
				  ]
				: []),
			...(this.state.area3Available
				? [
						{
							title: 'areasNextBranch',
							enabled: true,
						},
				  ]
				: []),
			{
				title: 'problemTypeTopLevel',
				enabled: this.isLocationFieldsSelected(),
			},
			...(this.state.problemTypeLevel2Available
				? [
						{
							title: 'problemTypeNextLevel',
							enabled: true,
						},
				  ]
				: []),
			...(this.state.problemTypeLevel3Available
				? [
						{
							title: 'problemTypeNextBranch',
							enabled: true,
						},
				  ]
				: []),
			...(this.state.assetsAvailable
				? [
						{
							title: 'asset',
							enabled: this.isLocationFieldsSelected() && this.isProblemTypeAndAssetSelected(),
						},
				  ]
				: []),
			...(this.state.hasSubAssets
				? [
						{
							title: WO_STEP_NAMES.SUB_ASSET,
							enabled: !!nullSafeGet('assetId', formData),
						},
				  ]
				: []),
			...(this.state.asset
				? [
						{
							title: 'assetCondition',
							enabled: true,
						},
				  ]
				: []),
			{
				title: 'title',
				enabled: this.isLocationFieldsSelected() && this.isProblemTypeAndAssetSelected(),
			},
			{
				title: 'photos',
				enabled:
					this.isLocationFieldsSelected() &&
					this.isProblemTypeAndAssetSelected() &&
					nullSafeGet('title', formData),
			},
			{
				title: 'priority',
				enabled:
					this.isLocationFieldsSelected() &&
					this.isProblemTypeAndAssetSelected() &&
					nullSafeGet('title', formData) &&
					imageCountMatched,
			},
			{
				title: 'completion',
				enabled:
					this.isLocationFieldsSelected() &&
					this.isProblemTypeAndAssetSelected() &&
					nullSafeGet('title', formData) &&
					this.isPrioritySelected() &&
					imageCountMatched,
			},
		];

		const isImageUploading = (getFieldValue('images') || []).some((_) => _.status === 'uploading');
		const isProcessing = this.isProcessing();

		const getNavSteps = () => {
			const allNavSteps = mergeTroubleshootingRoutes(
				defaultNavMenuSteps,
				nullSafeGetOrElse('state.troubleshootingRoutes', this, []),
				(route) => defaultNavMenuSteps.map((_) => _.title).indexOf(route.previousStep),
				(route) => ({
					title: `troubleshooting-${route.id}`,
					enabled: true,
				})
			);

			return allNavSteps;
		};

		const defaultSteps = {
			contractorClients: {
				id: 1,
				label: 'Client',
				component: (
					<div key={1} className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title">Which client needs service?</h3>
						<Form.Item className={'flex w-full flex-grow'}>
							{getFieldDecorator(`contractorClientId`, {
								rules: [
									{
										required: true,
										message: 'Please pick the client that needs service!',
									},
								],
								initialValue: nullSafeGet('contractorClientId', formData),
							})(
								<OWAsyncRadio
									mode="default"
									fieldName="contractorClientId"
									stateSlice={contractorClients}
									onChange={this.handleClient}
									onClick={this.handleClientClick}
									targetCollectionName={'WORK_ORDER_CREATION_AUTOCOMPLETE'}
									fetchMultiple={(ids, targetCollectionName) =>
										fetchMultipleContractorClients(ids, targetCollectionName)
									}
									fetchData={(
										searchText,
										targetCollectionName,
										pagination = null,
										sorting = null,
										filters = null
									) =>
										fetchContractorClients(
											{
												search: searchText || undefined,
											},
											targetCollectionName,
											pagination,
											sorting,
											filters
										)
									}
									renderRecord={(client) => (
										<div className="flex flex-row items-center lg:flex-col">{client.name}</div>
									)}
								/>
							)}
						</Form.Item>
					</div>
				),
			},
			locations: {
				id: 2,
				label: 'Location',
				component: (
					<div key={1} className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title">Which location needs service?</h3>
						<Form.Item className={'flex w-full flex-grow'}>
							{getFieldDecorator(`locationId`, {
								rules: [
									{
										required: true,
										message: 'Please pick the location that needs service!',
									},
								],
								initialValue: nullSafeGet('locationId', formData),
							})(
								<OWAsyncRadio
									mode="default"
									fieldName="locationId"
									stateSlice={this.state.isContractorLocationOnly ? contractorLocations : locations}
									onChange={this.handleLocation}
									onClick={this.handleLocationClick}
									targetCollectionName={'WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE'}
									fetchMultiple={(ids, targetCollectionName) =>
										this.state.isContractorLocationOnly
											? fetchMultipleContractorLocations(ids, targetCollectionName)
											: fetchMultipleLocations(ids, targetCollectionName)
									}
									fetchData={(
										searchText,
										targetCollectionName,
										pagination = null,
										sorting = null,
										filters = null
									) => {
										const fnToCall = this.state.isContractorLocationOnly
											? fetchContractorLocations
											: fetchLocationsLite;
										return fnToCall(
											{
												search: searchText || undefined,
												...(this.state.isContractorLocationOnly
													? { contractorClientId: nullSafeGet('contractorClient.id', this.state) }
													: {
															buyerCompanyId: nullSafeGet(
																'contractorClient.clientBuyerCompanyId',
																this.state
															),
															industryId: nullSafeGet(
																'contractorClient.clientBuyerCompany.industryId',
																this.state
															),
													  }),
											},
											targetCollectionName,
											pagination,
											sorting,
											filters
										);
									}}
									renderRecord={(location) => renderLocationRecord(location, currentUser)}
									renderIcon={(location) =>
										location.brand ? <ServiceRequestLocationRender location={location} /> : null
									}
								/>
							)}
						</Form.Item>
					</div>
				),
			},
			areasTopLevel: {
				id: 3,
				label: 'Area',
				component: (
					<div key={2} className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title">
							Which area is the request for?
						</h3>
						<Form.Item className={'flex w-full flex-grow'}>
							{getFieldDecorator(`areasTopLevel`, {
								rules: [
									{
										required: false,
									},
								],
								initialValue: nullSafeGet('areaLevel1Id', this.state),
							})(
								<OWAsyncRadio
									getDescription={(record) => record.description}
									autoPickFirstOption
									mode="default"
									fieldName="areasTopLevel"
									stateSlice={areas}
									additionalFilters={{
										locationId: nullSafeGet('location.id', this.state),
										locationTypeId: nullSafeGet('location.locationTypeId', this.state),
									}}
									onChange={this.handleAreaTopLevelChange}
									onClick={this.handleAreaTopLevelChange}
									targetCollectionName={'WORK_ORDER_FORM_AREAS_TOP_LEVEL_AUTOCOMPLETE'}
									fetchMultiple={(ids, targetCollectionName) =>
										fetchMultipleAreas(ids, targetCollectionName)
									}
									fetchData={(
										searchText,
										targetCollectionName,
										pagination = null,
										sorting = null,
										filters = null
									) =>
										fetchAreasTopLevel(
											{
												name: searchText,
											},
											targetCollectionName,
											pagination,
											sorting,
											filters
										)
									}
									renderRecord={(area) => area.name}
								/>
							)}
						</Form.Item>
						<Button
							size="large"
							type="ghost"
							onClick={() => this.goBack()}
							loading={isProcessing}
							disabled={isProcessing}
						>
							Back
						</Button>
					</div>
				),
			},
			areasNextLevel: {
				id: 4,
				label: 'Area - 2',
				component: (
					<div key={3} className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title">
							Which area is the request for?
						</h3>
						<Form.Item className={'flex w-full flex-grow'}>
							{getFieldDecorator(`areaId`, {
								rules: [
									{
										required: false,
									},
								],
								initialValue: nullSafeGet('areaLevel2Id', this.state),
							})(
								nullSafeGet('currentRoute', this.state) === 'areasNextLevel' ? (
									<OWAsyncRadio
										getDescription={(record) => record.description}
										autoPickFirstOption
										mode="default"
										fieldName="area"
										stateSlice={areas}
										additionalFilters={{
											locationId: nullSafeGet('location.id', this.state),
											locationTypeId: nullSafeGet('location.locationTypeId', this.state),
										}}
										onChange={this.handleAreaNextLevelChange}
										onClick={this.handleAreaNextLevelChange}
										targetCollectionName={'WORK_ORDER_FORM_AREAS_AUTOCOMPLETE'}
										fetchMultiple={(ids, targetCollectionName) =>
											fetchMultipleAreas(ids, targetCollectionName)
										}
										fetchData={(
											searchText,
											targetCollectionName,
											pagination = null,
											sorting = null,
											filters = null
										) =>
											fetchAreas(
												{
													name: searchText,
													parentId: nullSafeGet('areaPriorLevelId', this.state),
												},
												targetCollectionName,
												pagination,
												sorting,
												filters
											)
										}
										renderRecord={(area) => area.name}
									/>
								) : (
									<div />
								)
							)}
						</Form.Item>
						<Button
							size="large"
							type="ghost"
							onClick={() => this.goBack()}
							loading={isProcessing}
							disabled={isProcessing}
						>
							Back
						</Button>
					</div>
				),
			},
			areasNextBranch: {
				id: 5,
				label: 'Area - 3',
				component: (
					<div key={4} className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title">
							Which area is the request for?
						</h3>
						<Form.Item className={'flex w-full flex-grow'}>
							{getFieldDecorator(`areaIdNextLevel`, {
								rules: [
									{
										required: false,
									},
								],
								initialValue: nullSafeGet('areaLevel3Id', this.state),
							})(
								nullSafeGet('currentRoute', this.state) === 'areasNextBranch' ? (
									<OWAsyncRadio
										getDescription={(record) => record.description}
										autoPickFirstOption
										mode="default"
										fieldName="area"
										stateSlice={areas}
										additionalFilters={{
											locationId: nullSafeGet('location.id', this.state),
											locationTypeId: nullSafeGet('location.locationTypeId', this.state),
										}}
										onChange={this.handleAreaNextLevelBranchChange}
										onClick={this.handleAreaNextLevelBranchChange}
										targetCollectionName={'WORK_ORDER_FORM_AREAS_NEXT_LEVEL_AUTOCOMPLETE'}
										fetchMultiple={(ids, targetCollectionName) =>
											fetchMultipleAreas(ids, targetCollectionName)
										}
										fetchData={(
											searchText,
											targetCollectionName,
											pagination = null,
											sorting = null,
											filters = null
										) =>
											fetchAreas(
												{
													name: searchText,
													parentId: nullSafeGet('areaPriorLevelId', this.state),
												},
												targetCollectionName,
												pagination,
												sorting,
												filters
											)
										}
										renderRecord={(area) => area.name}
									/>
								) : (
									<div />
								)
							)}
						</Form.Item>
						<Button
							size="large"
							type="ghost"
							onClick={() => this.goBack()}
							loading={isProcessing}
							disabled={isProcessing}
						>
							Back
						</Button>
					</div>
				),
			},
			problemTypeTopLevel: {
				id: 6,
				label: 'Problem Type',
				component: (
					<div key={5} className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title">What kind of request is it?</h3>
						<Form.Item className={'flex w-full flex-grow'}>
							{getFieldDecorator(`problemTypeTopLevel`, {
								rules: [
									{
										required: false,
									},
								],
								initialValue: nullSafeGet('problemTypeLevel1Id', this.state),
							})(
								<OWAsyncRadio
									getDescription={(record) => record.description}
									autoPickFirstOption
									mode="default"
									fieldName="problemTypeTopLevel"
									stateSlice={
										this.state.isContractorLocationOnly ? contractorProblemTypes : problemTypes
									}
									additionalFilters={{
										areaId: nullSafeGetOrElse('area.id', this.state, undefined),
									}}
									onChange={this.handleProblemTypeTopLevelChange}
									onClick={this.handleProblemTypeTopLevelClick}
									targetCollectionName={'WORK_ORDER_PROBLEM_TYPES_TOP_LEVEL_AUTOCOMPLETE'}
									fetchMultiple={(ids, targetCollectionName) =>
										this.state.isContractorLocationOnly
											? fetchMultipleContractorProblemTypes
											: fetchMultipleProblemTypes(ids, targetCollectionName)
									}
									fetchData={(
										searchText,
										targetCollectionName,
										pagination = null,
										sorting = null,
										filters = null
									) => {
										const fnToCall = this.state.isContractorLocationOnly
											? fetchContractorProblemTypesTopLevel
											: fetchProblemTypesTopLevel;
										return fnToCall(
											{
												name: searchText,
												...(this.state.isContractorLocationOnly
													? { contractorClient: nullSafeGet('contractorClient.id', this.state) }
													: {
															locationId: nullSafeGet('location.id', this.state),
															industryId: nullSafeGetOrElse('industryId', this.state, 1),
															buyerCompanyId: nullSafeGetOrElse('buyerCompanyId', this.state, -1),
													  }),
											},
											targetCollectionName,
											pagination,
											sorting,
											filters
										);
									}}
									renderRecord={(problemType, records, searchText) =>
										nullSafeGet('length', searchText) ? problemType.hierarchyName : problemType.name
									}
								/>
							)}
						</Form.Item>
						<Button
							size="large"
							type="ghost"
							onClick={() => this.goBack()}
							loading={isProcessing}
							disabled={isProcessing}
						>
							Back
						</Button>
					</div>
				),
			},
			problemTypeNextLevel: {
				id: 7,
				label: 'Problem Type - 2',
				component: (
					<div key={6} className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title">What kind of request is it?</h3>
						<Form.Item className={'flex w-full flex-grow'}>
							{getFieldDecorator(`problemTypeId`, {
								rules: [
									{
										required: false,
									},
								],
								initialValue: nullSafeGet('problemTypeLevel2Id', this.state),
							})(
								nullSafeGet('currentRoute', this.state) === 'problemTypeNextLevel' ? (
									<OWAsyncRadio
										getDescription={(record) => record.description}
										autoPickFirstOption
										mode="default"
										fieldName="problemType"
										stateSlice={
											this.state.isContractorLocationOnly ? contractorProblemTypes : problemTypes
										}
										additionalFilters={{
											areaId: nullSafeGetOrElse('area.id', this.state, undefined),
										}}
										onChange={this.handleProblemTypeNextLevelChange}
										onClick={this.handleProblemTypeNextLevelChange}
										targetCollectionName={'WORK_ORDER_FORM_PROBLEM_TYPES_AUTOCOMPLETE'}
										fetchMultiple={(ids, targetCollectionName) =>
											this.state.isContractorLocationOnly
												? fetchMultipleContractorProblemTypes
												: fetchMultipleProblemTypes(ids, targetCollectionName)
										}
										fetchData={(
											searchText,
											targetCollectionName,
											pagination = null,
											sorting = null,
											filters = null
										) => {
											const fnToCall = this.state.isContractorLocationOnly
												? fetchContractorProblemTypes
												: fetchProblemTypes;
											return fnToCall(
												{
													name: searchText,
													parentId: nullSafeGet('problemTypePriorLevelId', this.state),
												},
												targetCollectionName,
												pagination,
												sorting,
												filters
											);
										}}
										renderRecord={(problemType, records, searchText) =>
											nullSafeGet('length', searchText)
												? problemType.hierarchyName
												: problemType.name
										}
									/>
								) : (
									<div />
								)
							)}
						</Form.Item>
						<Button
							size="large"
							type="ghost"
							onClick={() => this.goBack()}
							loading={isProcessing}
							disabled={isProcessing}
						>
							Back
						</Button>
					</div>
				),
			},
			problemTypeNextBranch: {
				id: 8,
				label: 'Problem Type - 3',
				component: (
					<div key={7} className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title">What kind of request is it?</h3>
						<Form.Item className={'flex w-full flex-grow'}>
							{getFieldDecorator(`problemTypeIdNextLevel`, {
								rules: [
									{
										required: false,
									},
								],
								initialValue: nullSafeGet('problemTypeLevel3Id', this.state),
							})(
								nullSafeGet('currentRoute', this.state) === 'problemTypeNextBranch' ? (
									<OWAsyncRadio
										getDescription={(record) => record.description}
										autoPickFirstOption
										mode="default"
										fieldName="problemType"
										stateSlice={
											this.state.isContractorLocationOnly ? contractorProblemTypes : problemTypes
										}
										additionalFilters={{
											areaId: nullSafeGetOrElse('area.id', this.state, undefined),
										}}
										onChange={this.handleProblemTypeNextLevelBranchChange}
										onClick={this.handleProblemTypeNextLevelBranchChange}
										targetCollectionName={'WORK_ORDER_FORM_PROBLEM_TYPES_NEXT_LEVEL_AUTOCOMPLETE'}
										fetchMultiple={(ids, targetCollectionName) =>
											this.state.isContractorLocationOnly
												? fetchMultipleContractorProblemTypes
												: fetchMultipleProblemTypes(ids, targetCollectionName)
										}
										fetchData={(
											searchText,
											targetCollectionName,
											pagination = null,
											sorting = null,
											filters = null
										) => {
											const fnToCall = this.state.isContractorLocationOnly
												? fetchContractorProblemTypes
												: fetchProblemTypes;
											return fnToCall(
												{
													name: searchText,
													parentId: nullSafeGet('problemTypePriorLevelId', this.state),
												},
												targetCollectionName,
												pagination,
												sorting,
												filters
											);
										}}
										renderRecord={(problemType, records, searchText) =>
											nullSafeGet('length', searchText)
												? problemType.hierarchyName
												: problemType.name
										}
									/>
								) : (
									<div />
								)
							)}
						</Form.Item>
						<Button
							size="large"
							type="ghost"
							onClick={() => this.goBack()}
							loading={isProcessing}
							disabled={isProcessing}
						>
							Back
						</Button>
					</div>
				),
			},
			asset: {
				id: 9,
				label: 'Asset',
				component: (
					<div key={8} className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title" style={{ marginBottom: 16 }}>
							Is the problem affecting a particular piece of equipment?
						</h3>
						<Form.Item className={'flex w-full flex-grow'}>
							<div style={{ textAlign: 'center', marginBottom: 24 }}>
								{nullSafeGet('id', this.state.problemType) ? (
									<Button
										onClick={() => this.goNext([], WO_STEP_NAMES.TITLE, WO_STEP_NAMES.ASSET)}
										type="link"
										loading={isProcessing}
										disabled={isProcessing}
									>
										Skip
									</Button>
								) : null}
							</div>
							{getFieldDecorator(`assetId`, {
								initialValue: nullSafeGet('assetId', formData),
							})(
								<OWAsyncRadio
									mode="default"
									fieldName="assetId"
									stateSlice={assets}
									onChange={this.handleAsset}
									onClick={this.handleAssetClick}
									targetCollectionName={'SERVICE_REQUEST_FORM_ASSETS_AUTOCOMPLETE'}
									keepFetchedOrder={true}
									fetchMultiple={(ids, targetCollectionName) =>
										fetchMultipleAssets(ids, targetCollectionName)
									}
									fetchData={(
										searchText,
										targetCollectionName,
										pagination = null,
										sorting = {
											sort_by: 'assetNumber',
											order: 'ascend',
										},
										filters = null
									) =>
										fetchAssets(
											{
												search: searchText,
												topLevelOnly: 'true',
											},
											targetCollectionName,
											pagination,
											sorting,
											filters
										)
									}
									renderRecord={(asset) => (
										<>
											<div className="flex flex-col">
												<Ellipsis tooltip={true} length={12}>
													{asset.name}
												</Ellipsis>
												<AssetNumberDisplay asset={asset} style={{ marginTop: 8 }} />
											</div>
											{getWarrantyStatus(nullSafeGet('warranties.0', asset)) === 'Active' ? (
												<div style={{ marginTop: '8px', marginBottom: '8px', fontWeight: 500 }}>
													Under Warranty
												</div>
											) : null}
										</>
									)}
									additionalFilters={getAssetFilterForWOCreation(ROLE_TYPES.SUPPLIER)(
										companyConfig,
										currentUser,
										this.state
									)}
								/>
							)}
							<div className="flex w-full flex-row justify-center">
								<Button
									size="large"
									type="ghost"
									onClick={() => this.goBack()}
									loading={isProcessing}
									disabled={isProcessing}
								>
									Back
								</Button>
								{nullSafeGet('id', this.state.problemType) ? (
									<Button
										className="ml-4 flex"
										size="large"
										type="primary"
										disabled={isProcessing}
										loading={isProcessing}
										onClick={() =>
											this.goNextAfterBriefPause(
												['assetId'],
												this.state.hasSubAssets ? WO_STEP_NAMES.SUB_ASSET : WO_STEP_NAMES.TITLE,
												WO_STEP_NAMES.ASSET
											)
										}
									>
										Next step
									</Button>
								) : null}
							</div>
						</Form.Item>
					</div>
				),
			},
			[WO_STEP_NAMES.SUB_ASSET]: {
				id: 9.5,
				label: 'Sub Assets',
				component: (
					<div className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title" style={{ marginBottom: 16 }}>
							Which sub assets are affected?
						</h3>
						<SubAssetSelectionStep
							parentAssetId={parseInt(nullSafeGet('assetId', formData), 10)}
							value={this.state.selectedSubAssetIds}
							onChange={(ids) => this.setState({ selectedSubAssetIds: ids })}
							fetchSubAssets={this.props.fetchSubAssets}
						/>
						<div className="flex flex-row" style={{ marginTop: 16 }}>
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							<Button
								size="large"
								type="primary"
								className="ml-4"
								loading={isProcessing}
								disabled={isProcessing}
								onClick={() =>
									this.goNextAfterBriefPause(
										[],
										WO_STEP_NAMES.ASSET_CONDITION,
										WO_STEP_NAMES.SUB_ASSET
									)
								}
							>
								Next step
							</Button>
						</div>
					</div>
				),
			},
			assetCondition: {
				id: 10,
				label: 'Asset Status',
				component: (
					<div key={8} className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title" style={{ marginBottom: 16 }}>
							{`Is the asset functioning?`}
						</h3>
						<Form.Item style={{ width: '100%' }}>
							{getFieldDecorator(`isAssetDown`, {
								initialValue: nullSafeGetOrElse('isAssetDown', formData, ''),
							})(
								<OWRadio
									fieldName="assetId"
									onChange={this.handleAssetCondition}
									onClick={this.handleAssetCondition}
									renderRecord={(r) => r.name}
									records={{
										false: {
											id: 'false',
											name: 'Yes',
										},
										true: {
											id: 'true',
											name: 'No',
										},
									}}
									sorter={(records) => records.sort((a, b) => (a.id > b.id ? 1 : -1))}
								/>
							)}
						</Form.Item>
						<div className="flex flex-row">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
						</div>
					</div>
				),
			},
			assetCheck: {
				id: 21,
				label: 'Asset Check',
				component: (
					<div key={8} className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title" style={{ marginBottom: 16 }}>
							{`Do you have the asset information with you?`}
						</h3>
						<Form.Item style={{ width: '100%' }}>
							{getFieldDecorator(`isAssetKnown`, {
								initialValue: nullSafeGetOrElse('isAssetKnown', formData, ''),
							})(
								<OWRadio
									fieldName="isAssetKnown"
									onChange={this.handleAssetCheck}
									onClick={this.handleAssetCheck}
									renderRecord={(r) => r.name}
									records={{
										true: {
											id: 'true',
											name: 'Yes',
										},
										false: {
											id: 'false',
											name: 'No',
										},
									}}
									sorter={(records) => records.sort((a, b) => (a.id < b.id ? 1 : -1))}
								/>
							)}
						</Form.Item>
						<div className="flex flex-row">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
						</div>
					</div>
				),
			},
			title: {
				id: 11,
				label: 'Description',
				component: (
					<div key={9} className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title">
							In a few words, what's this request about?
						</h3>
						<Form.Item className={'flex w-full flex-grow'}>
							{getFieldDecorator(`title`, {
								rules: [{ required: true, message: 'Please describe the request.' }],
								initialValue: nullSafeGet('title', formData),
							})(
								<Input.TextArea
									autoSize
									showCount
									maxLength={120}
									style={{ width: '100%', marginBottom: 40 }}
									size="large"
								/>
							)}
							<div className="flex w-full flex-row justify-center">
								<Button
									size="large"
									type="ghost"
									onClick={() => this.goBack()}
									loading={isProcessing}
									disabled={isProcessing}
								>
									Back
								</Button>
								<Button
									size="large"
									type="primary"
									className="ml-4"
									disabled={isProcessing}
									loading={isProcessing}
									onClick={() => this.handleTitle()}
								>
									Next step
								</Button>
							</div>
						</Form.Item>
					</div>
				),
			},
			photos: {
				id: 12,
				label: 'Photos',
				component: (
					<div key={10} className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title">Want to add some photos?</h3>
						<Form.Item
							style={{
								marginBottom: 20,
								width: '100%',
							}}
							className="text-center"
						>
							{getFieldDecorator(`images`, {
								valuePropName: 'fileList',
								getValueFromEvent: normFile,
								initialValue: this.state.allPhotos,
								rules: getImageCountErrorRules(minPhotosCount, imageCountErrorMessage),
							})(
								<OWUpload
									accept="image/*"
									name="file"
									listType="picture-card"
									className="workorder-image-uploader"
									multiple={true}
									headers={uploadHeaders}
									onPreview={this.handlePreview}
									action={`${BACKEND_URI}/api/v1/supplier/file/upload`}
									beforeUpload={imageUploadValidation}
									onChange={this.handleImageUpdate}
								>
									<div style={{ display: 'inline' }}>
										<LegacyIcon type={this.state.uploadLoading ? 'loading' : 'plus'} />
										<div className="ant-upload-text">Upload</div>
									</div>
									<Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
										<img alt="example" style={{ width: '100%' }} src={previewImage} />
									</Modal>
								</OWUpload>
							)}
						</Form.Item>
						<div className="flex flex-row">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							<Button
								size="large"
								type="primary"
								className="ml-4"
								loading={isImageUploading || isProcessing}
								disabled={isProcessing}
								onClick={() =>
									this.goNextAfterBriefPause(
										['images'],
										WO_STEP_NAMES.PRIORITY,
										WO_STEP_NAMES.PHOTOS
									)
								}
							>
								Next step
							</Button>
						</div>
					</div>
				),
			},
			duplicateCheck: {
				id: 22,
				label: 'Possible Duplicates',
				component: (
					<div key={11} className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title">
							We found potential duplicate requests. Do you still want to open a new request?
						</h3>
						<Table
							pagination={false}
							showHeader={false}
							dataSource={nullSafeGetOrElse('duplicateWorkOrders', this.state, [])}
							columns={duplicateWorkOrderColumns}
						/>
						<Form.Item style={{ width: '100%' }}>
							{getFieldDecorator(`isDuplicate`, {
								initialValue: nullSafeGet('isDuplicate', formData),
							})(
								<OWRadio
									fieldName="isDuplicate"
									onChange={this.handleDuplicate}
									onClick={this.handleDuplicate}
									renderRecord={(option) => option.name}
									records={{
										1: { id: 1, name: 'No, cancel this request' },
										2: { id: 2, name: 'Yes, this is a different issue' },
									}}
									sorter={(records) => records.sort((a, b) => (a.id > b.id ? 1 : -1))}
								/>
							)}
						</Form.Item>
						<Button
							size="large"
							type="ghost"
							onClick={() => this.goBack()}
							loading={isProcessing}
							disabled={isProcessing}
						>
							Back
						</Button>
					</div>
				),
			},
			priority: {
				id: 13,
				label: 'Priority',
				component: (
					<div key={11} className="supplierNewWorkOrderWizardPage__section">
						<h3 className="supplierNewWorkOrderWizardPage__title">
							How quickly does this need to get fixed?
						</h3>
						<Form.Item className={'flex w-full flex-grow'}>
							<div
								style={{
									marginBottom: 20,
								}}
							>
								{getFieldDecorator(`woPriorityId`, {
									initialValue: nullSafeGet('woPriority.id', this.state),
								})(
									<OWAsyncRadio
										mode="default"
										fieldName="woPriorityId"
										stateSlice={
											this.state.isContractorLocationOnly
												? contractorWOPriorities
												: workOrderPriorities
										}
										onChange={
											this.state.isContractorLocationOnly
												? this.handleContractorWOPriority
												: this.handleWorkOrderPriority
										}
										onClick={
											this.state.isContractorLocationOnly
												? this.handleContractorWOPriorityClick
												: this.handleWorkOrderPriorityClick
										}
										targetCollectionName={'WORK_ORDER_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE'}
										fetchMultiple={(ids, targetCollectionName) =>
											this.state.isContractorLocationOnly
												? fetchMultipleContractorWOPriorities(ids, targetCollectionName)
												: fetchMultipleWorkOrderPriorities(ids, targetCollectionName)
										}
										fetchData={(
											searchText,
											targetCollectionName,
											pagination = null,
											sorting = {
												sort_by: 'expectedResolutionInSeconds',
												order: 'descend',
											},
											filters = null
										) => {
											const fnToCall = this.state.isContractorLocationOnly
												? fetchContractorWOPriorities
												: fetchWorkOrderPriorities;
											return fnToCall(
												{
													name: searchText,
													contractorClientId: nullSafeGet('contractorClientId.id', this.state),
												},
												targetCollectionName,
												{ pageSize: 50, current: 1 },
												sorting,
												filters
											).then((data) => {
												const { updateWOPriorityRecords } = this.props;
												return new Promise((resolve) => {
													const locationBuyerCompanyId = nullSafeGetOrElse(
														'state.location.clientBuyerCompanyId',
														this,
														-1
													);
													const filteredData = data.find(
														(_) => _.buyerCompanyId === locationBuyerCompanyId
													)
														? data.filter((_) => _.buyerCompanyId === locationBuyerCompanyId)
														: data.filter((_) => _.buyerCompanyId === -1);
													updateWOPriorityRecords(
														filteredData,
														filteredData.length,
														targetCollectionName,
														{ ...pagination, total: filteredData.length },
														sorting,
														filters
													);
													resolve(filteredData);
												});
											});
										}}
										renderRecord={(workOrderPriority) => workOrderPriority.name}
										keepFetchedOrder
									/>
								)}
							</div>
							<div className="flex w-full flex-row justify-center">
								<Button
									size="large"
									type="ghost"
									onClick={() => this.goBack()}
									loading={isProcessing}
									disabled={isProcessing}
								>
									Back
								</Button>
								<Button
									size="large"
									type="primary"
									className="ml-4"
									disabled={isProcessing}
									loading={isProcessing}
									onClick={() => {
										nullSafeGet('woPriority.id', this.state)
											? this.goNextAfterBriefPause(
													[],
													this.state.isContractorLocationOnly
														? WO_STEP_NAMES.NTE
														: WO_STEP_NAMES.COMPLETION,
													WO_STEP_NAMES.PRIORITY
											  )
											: message.error('Work order priority cannot be empty!');
									}}
								>
									Next step
								</Button>
							</div>
						</Form.Item>
					</div>
				),
			},
			...(this.state.isContractorLocationOnly && {
				nte: {
					id: 14,
					label: 'NTE',
					component: (
						<div key={14} className="supplierNewWorkOrderWizardPage__section">
							<h3 className="supplierNewWorkOrderWizardPage__title">
								Would you like to set a Not-to-Exceed amount?
							</h3>
							<div style={{ display: 'flex', flexDirection: 'row', gap: 24 }}>
								<Form.Item>
									{getFieldDecorator(`nte`, {
										validateTrigger: 'onChange',
										initialValue: nullSafeGet(`nte`, formData),
									})(
										<InputNumber
											placeholder="Enter a value.."
											style={{ width: '200px' }}
											size="large"
											addonAfter={currency.id}
											onChange={(value) => this.setNTE(value)}
										/>
									)}
								</Form.Item>
								{/* {nullSafeGet('supplier.currencyId', this.state) && !isSameCurrency ? (
								<div style={{ display: 'flex', flexDirection: 'row' }}>
									<i
										className="icons8-font icons8-data-transfer flex"
										style={{ fontSize: 24, marginTop: 16, marginRight: 26 }}
									/>
									<InputNumber
										style={{ width: '200px' }}
										size="large"
										disabled={true}
										addonAfter={workOrderCurrency.id}
										value={(this.state.nte * currencyExchangeRateLocationToSupplier).toFixed(2)}
									/>
								</div>
							) : null} */}
							</div>
							<div className="flex flex-row pt-4">
								<Button
									size="large"
									type="ghost"
									onClick={() => this.goBack()}
									loading={isProcessing}
									disabled={isProcessing}
								>
									Back
								</Button>
								<Button
									size="large"
									type="primary"
									className="ml-4"
									disabled={isProcessing}
									loading={isProcessing}
									onClick={() => {
										this.goNextAfterBriefPause([], WO_STEP_NAMES.COMPLETION, WO_STEP_NAMES.NTE);
									}}
								>
									Next step
								</Button>
							</div>
						</div>
					),
				},
			}),
			completion: {
				id: 15,
				label: 'Summary',
				component: (
					<div
						key={12}
						className="supplierNewWorkOrderWizardPage__section"
						style={{ width: '100%' }}
					>
						<h3 className="supplierNewWorkOrderWizardPage__title">Summary</h3>
						<div style={{ marginBottom: 24, maxWidth: '60%' }}>
							<WorkOrderSummary workOrderDetails={workOrderDetails} photoStrings={photoStrings} />
						</div>
						<div className="flex w-full flex-row justify-center">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							<Button
								onClick={
									this.state.onlyForPreview
										? onCancelRequest(this.props, this.state)
										: this.handleSubmit
								}
								onClick={this.handleSubmit}
								type="primary"
								size="large"
								className="ml-4"
								loading={isProcessing}
								disabled={isProcessing}
							>
								{this.state.onlyForPreview ? 'Exit Preview' : 'Create Work Order'}
							</Button>
						</div>
					</div>
				),
			},
		};

		const getSteps = () => {
			const allStepKeys = mergeTroubleshootingRoutes(
				Object.keys(defaultSteps),
				nullSafeGetOrElse('state.troubleshootingRoutes', this, []),
				(route) => Object.keys(defaultSteps).indexOf(route.previousStep),
				(route) => `troubleshooting-${route.id}`
			);

			const troubleshootingSteps = getTroubleshootingSteps();

			const allSteps = allStepKeys.reduce((steps, key) => {
				return {
					...steps,
					[key]: key.startsWith('troubleshooting') ? troubleshootingSteps[key] : defaultSteps[key],
				};
			}, {});

			return allSteps;
		};

		const allSteps = getSteps();
		const allNavSteps = getNavSteps();
		const currentStepKey = location.pathname.split('/')[location.pathname.split('/').length - 1];
		const currentStepIndex = allNavSteps.map((_) => _.title).indexOf(currentStepKey);
		const currentCompletionPercentage = ((currentStepIndex * 1.0) / allNavSteps.length) * 100;

		return (
			<div className="supplierNewWorkOrderWizardPage">
				<Drawer
					width={240}
					title="Overview"
					bodyStyle={{ padding: '16px 0' }}
					placement="left"
					closable={true}
					onClose={this.handleNavMenuClose}
					visible={this.state.navMenuVisible}
				>
					<Menu
						onClick={this.handleNavMenuClick}
						style={{ width: 240 }}
						selectedKeys={[this.state.currentRoute]}
						mode="inline"
					>
						{allNavSteps.map((k) => {
							const step = allSteps[k.title];
							return (
								<Menu.Item disabled={!k.enabled || isProcessing} key={k.title}>
									{step.label}
								</Menu.Item>
							);
						})}
					</Menu>
				</Drawer>
				<div
					style={{
						position: 'absolute',
						display: 'flex',
						alignItems: 'center',
						zIndex: 3,
						right: 16,
						top: 8,
					}}
				>
					<Button type="link" onClick={() => this.props.history.push(this.state.backLinkTo)}>
						Cancel Request
					</Button>
				</div>
				<div className="supplierNewWorkOrderWizardPage__inner">
					{Object.keys(allSteps).map((k) => {
						const step = allSteps[k];
						return (
							<Route
								key={step.id}
								path={`/supplier/workOrders/newContractorWorkOrder/${k}`}
								render={() => step.component}
								exact={true}
							/>
						);
					})}
				</div>
				<div
					style={{
						position: 'absolute',
						display: 'flex',
						alignItems: 'center',
						zIndex: 3,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'white',
						border: '1px solid #f5f5f5',
						width: '100%',
					}}
				>
					<Button
						style={{ display: 'inline-block', margin: '8px 16px 8px 8px' }}
						size="large"
						icon={<MenuOutlined />}
						onClick={this.handleNavMenuOpen}
					>
						Overview
					</Button>
					<Progress
						style={{ margin: '8px 16px 8px 8px' }}
						strokeLinecap="square"
						strokeColor="#2792b0"
						percent={currentCompletionPercentage}
						showInfo={false}
					/>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	redirectForwardUrl: ownProps.redirectForwardUrl,
	formData: state.work_orders.formData,
	currentUser: state.session.currentUser,
	companyConfig: state.company_config.detail,
	spendCategories: state.spend_categories,
	problemTypes: state.problem_types,
	contractorProblemTypes: state.contractor_problem_types,
	contractorLocations: state.contractor_locations,
	locations: state.locations,
	creating: state.work_orders.creating,
	workOrderPriorities: state.work_order_priorities,
	assets: state.assets,
	areas: state.areas,
	location: ownProps.location,
	contractorClients: state.contractor_clients,
	contractorWOPriorities: state.contractor_wo_priorities,
});

const mapDispatchToProps = (dispatch) => ({
	saveFormData: (formData) => dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.saveFormData(formData)),
	clearFormData: () => dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.clearFormData()),
	fetchMultipleContractorLocations: (ids, targetCollectionName) =>
		dispatch(contractorLocationsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchContractorLocation: (id) =>
		dispatch(contractorLocationsRestCrudThunksForSupplier.readOne(id)),
	fetchContractorLocations: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			contractorLocationsRestCrudThunksForSupplier.read(
				{ ...(params || {}) },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleLocations: (ids, targetCollectionName) =>
		dispatch(locationsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchLocation: (id) => dispatch(locationsRestCrudThunksForSupplier.readOne(id)),
	fetchLocationsLite: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			locationsRestCrudThunksForSupplier.readLite(
				{
					...params,
					includeBuyerLocationsForPayingSupplier: true,
					hydrate: 'brand,buyerCompany',
				},
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleContractorClients: (ids, targetCollectionName) =>
		dispatch(contractorClientsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchContractorClient: (id) => dispatch(contractorClientsRestCrudThunksForSupplier.readOne(id)),
	fetchContractorClients: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			contractorClientsRestCrudThunksForSupplier.read(
				{ ...(params || {}) },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleContractorWOPriorities: (ids, targetCollectionName) =>
		dispatch(
			contractorWOPrioritiesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
		),
	fetchContractorWOPriority: (id) =>
		dispatch(contractorWOPrioritiesRestCrudThunksForSupplier.readOne(id)),
	fetchContractorWOPriorities: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			contractorWOPrioritiesRestCrudThunksForSupplier.read(
				{ ...(params || {}) },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchAsset: (id) => dispatch(assetsRestCrudThunksForSupplier.readOne(id)),
	fetchSubAssets: (parentId) =>
		dispatch(
			assetsRestCrudThunksForSupplier.read(
				{ parentIds: parentId },
				SUB_ASSETS_TARGET_COLLECTION,
				{ current: 1, pageSize: 1000 },
				{ sort_by: 'name', order: 'ascend' }
			)
		),
	fetchArea: (id) => dispatch(areasRestCrudThunksForSupplier.readOne(id)),
	fetchMultipleAreas: (ids, targetCollectionName) =>
		dispatch(areasRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchAreas: (params, targetCollectionName, pagination, sorting, filters, addToTargetCollection) =>
		dispatch(
			areasRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleAssets: (ids, targetCollectionName) =>
		dispatch(assetsRestCrudThunksForSupplier.readLite({ ids }, targetCollectionName)),
	fetchAssets: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			assetsRestCrudThunksForSupplier.readLite(
				{ ...params, view: 'workOrderCreation' },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchAreasTopLevel: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			areasTopLevelForSupplier(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchProblemType: (id) => dispatch(problemTypesRestCrudThunksForSupplier.readOne(id)),
	fetchMultipleProblemTypes: (ids, targetCollectionName) =>
		dispatch(problemTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchProblemTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			problemTypesRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchProblemTypesTopLevel: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			problemTypesTopLevelForSupplier(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchContractorProblemType: (id) =>
		dispatch(contractorProblemTypesRestCrudThunksForSupplier.readOne(id)),
	fetchContractorMultipleProblemTypes: (ids, targetCollectionName) =>
		dispatch(
			contractorProblemTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
		),
	fetchContractorProblemTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			contractorProblemTypesRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchContractorProblemTypesTopLevel: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			contractorProblemTypesTopLevel(ROLE_TYPES.SUPPLIER)(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchSpendCategory: (id) => dispatch(spendCategoriesRestCrudThunksForSupplier.readOne(id)),
	fetchMultipleSpendCategory: (ids, targetCollectionName) =>
		dispatch(spendCategoriesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchSpendCategories: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			spendCategoriesRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchWorkOrderAttributes: (params) =>
		dispatch(workOrderAttributesRestCrudThunksForSupplier.read(params)),
	fetchWorkOrderPriority: (id) =>
		dispatch(workOrderPrioritiesRestCrudThunksForSupplier.readOne(id)),
	fetchWorkOrderPriorities: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			workOrderPrioritiesWithoutPMRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleWorkOrderPriorities: (ids, targetCollectionName) =>
		dispatch(workOrderPrioritiesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchSupplierFacility: (id) => dispatch(supplierFacilitiesRestCrudThunksForSupplier.readOne(id)),
	updateWorkOrdersFilters: (filters, targetCollection) =>
		dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)),
	submitWorkOrderForm: (workOrder) =>
		dispatch(workOrdersRestCrudThunksForSupplier.create(workOrder)),
	fetchTroubleshooting: (params) => dispatch(troubleshootingRestCrudThunksForSupplier.read(params)),
	fetchWorkOrders: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			workOrdersRestCrudThunksForSupplier.searchAndHydrate(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection,
				workOrderSearchAndAPIAdaptor
			)
		),
	findDuplicateWorkOrders: (params) => findDuplicateWorkOrdersForSupplier(params),
	createTroubleshootingAnswersBulk: (entities) =>
		dispatch(troubleshootingAnswersRestCrudThunksForSupplier.createBulk(entities)),
	updateWalkthrough: (walkthrough) =>
		dispatch(walkthroughsRestCrudThunksForSupplier.update(walkthrough)),
	getWalkthrough: (id) => dispatch(walkthroughsRestCrudThunksForSupplier.readOne(id)),
	deleteWorkOrderFromRedux: (entity) =>
		dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.deleteSuccess(entity)),
	linkWorkOrders: (baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders) =>
		dispatch(linkWorkOrderForSupplier(baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders)),
	updateWOPriorityRecords: (
		records,
		count,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			WORK_ORDER_PRIORITIES_CRUD_ACTION_CREATORS.fetchSuccess(
				records,
				count,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
});

export default withRouter<any, any>(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(
		Form.create<SupplierNewWorkOrderWizardProps>({
			onValuesChange: (props, changedFields) => {
				props.saveFormData(changedFields);
			},
		})(ContractorNewWorkOrderWizardPage)
	)
);
